export const SETTINGS_ACCOUNT_URL = '/:accountId/settings/account';

export const SETTINGS_ACCOUNT_GENERAL_URL = `${SETTINGS_ACCOUNT_URL}/general`;

export const SETTINGS_ACCOUNT_UNIFORMS_URL = `${SETTINGS_ACCOUNT_URL}/branch/:branchId/uniforms`;

export const SETTINGS__ACCOUNTS_TABS = [
  'general',
  'employee-profile',
  'scheduling-timesheet',
  'payroll',
  'rules-engine',
  'help-desk',
  'timesheet-fields',
  'supplier-settings',
  'client-settings',
  'company-profile',
  'admin-management',
  'kiosk'
];

export const SETTINGS__ACCOUNTS_HOST_TABS = ['general', 'uniforms'];

export const SETTINGS_ACCOUNT_BRANCH_URL = '/:accountId/settings/account/branch/:branchId/scheduling-timesheet';
export const SETTINGS_ACCOUNT_HELP_DESK_URL = '/:accountId/settings/account/branch/:branchId/help-desk';
export const SETTINGS_ACCOUNT_HELP_DESK_SETTINGS_URL = '/:accountId/settings/account/help-desk/settings';
export const SETTINGS_ACCOUNT_UNBOOK_REASONS_URL = '/:accountId/settings/account/unbook-reasons';
export const SETTINGS_ACCOUNT_SUPPLIERS_SETTINGS = '/:accountId/settings/account/supplier-settings';
export const SETTINGS_ACCOUNT_CLIENTS_SETTINGS = '/:accountId/settings/account/client-settings';
export const SETTINGS_ACCOUNT_KIOSK = '/:accountId/settings/account/kiosk';

export const LOCATION_INSTRUCTIONS_MAX_LENGTH = 500;
export const MAX_LOCATION_ATTACHMENTS = 2;

export const JOB_DESCRIPTION_MAX_LENGTH = 2000;

export const DEFAULT_POSITION_RATE_EFFECTIVE_DATE = '1990-01-01';
